/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ApptReminders/view.blocks to change it.
import React from 'react'
import SetupAction from './SetupAction/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function ApptReminders({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Onboarding/ApptReminders"
  
}) {
  return (<React.Fragment
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h2"
 text="Appointment Reminders"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Setup automations required to send appointment reminders."
 fontStyle="italic"
/>
<SetupAction
  viewPath={`${viewPath}/SetupAction`}
/>
{children}
</React.Fragment>)
}